import { render, staticRenderFns } from "./profileTabs.vue?vue&type=template&id=85d65f98&"
import script from "./profileTabs.vue?vue&type=script&lang=js&"
export * from "./profileTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports